/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

module.exports = {
  zdColorBlack: '#000',
  zdColorGreen100: '#edf8f4',
  zdColorGreen200: '#d1e8df',
  zdColorGreen300: '#aecfc2',
  zdColorGreen400: '#5eae91',
  zdColorGreen500: '#228f67',
  zdColorGreen600: '#038153',
  zdColorGreen700: '#186146',
  zdColorGreen800: '#0b3b29',
  zdColorGrey100: '#f8f9f9',
  zdColorGrey200: '#e9ebed',
  zdColorGrey300: '#d8dcde',
  zdColorGrey400: '#c2c8cc',
  zdColorGrey500: '#87929d',
  zdColorGrey600: '#68737d',
  zdColorGrey700: '#49545c',
  zdColorGrey800: '#2f3941',
  zdColorBlue100: '#edf7ff',
  zdColorBlue200: '#cee2f2',
  zdColorBlue300: '#adcce4',
  zdColorBlue400: '#5293c7',
  zdColorBlue500: '#337fbd',
  zdColorBlue600: '#1f73b7',
  zdColorBlue700: '#144a75',
  zdColorBlue800: '#0f3554',
  zdColorKale100: '#f5fbfc',
  zdColorKale200: '#c1d6d9',
  zdColorKale300: '#819a9e',
  zdColorKale400: '#56777a',
  zdColorKale500: '#335d63',
  zdColorKale600: '#04444d',
  zdColorKale700: '#03363d',
  zdColorKale800: '#012b30',
  zdColorRed100: '#fff0f1',
  zdColorRed200: '#f5d5d8',
  zdColorRed300: '#f5b5ba',
  zdColorRed400: '#e35b66',
  zdColorRed500: '#d93f4c',
  zdColorRed600: '#cc3340',
  zdColorRed700: '#8c232c',
  zdColorRed800: '#681219',
  zdColorYellow100: '#fff8ed',
  zdColorYellow200: '#fff0db',
  zdColorYellow300: '#fcdba9',
  zdColorYellow400: '#ffb648',
  zdColorYellow500: '#f5a133',
  zdColorYellow600: '#ed961c',
  zdColorYellow700: '#ad5e18',
  zdColorYellow800: '#703b15',
  zdColorWhite: '#fff',
  zdColorSecondaryAzure400: '#3091ec',
  zdColorSecondaryAzure600: '#1371d6',
  zdColorSecondaryCrimson400: '#e34f32',
  zdColorSecondaryCrimson600: '#c72a1c',
  zdColorSecondaryFuschia400: '#d653c2',
  zdColorSecondaryFuschia600: '#a81897',
  zdColorSecondaryLemon400: '#ffd424',
  zdColorSecondaryLemon600: '#ffbb10',
  zdColorSecondaryLime400: '#43b324',
  zdColorSecondaryLime600: '#2e8200',
  zdColorSecondaryMint400: '#00a656',
  zdColorSecondaryMint600: '#058541',
  zdColorSecondaryOrange400: '#de701d',
  zdColorSecondaryOrange600: '#bf5000',
  zdColorSecondaryPink400: '#ec4d63',
  zdColorSecondaryPink600: '#d42054',
  zdColorSecondaryPurple400: '#b552e2',
  zdColorSecondaryPurple600: '#6a27b8',
  zdColorSecondaryRoyal400: '#5d7df5',
  zdColorSecondaryRoyal600: '#3353e2',
  zdColorSecondaryTeal400: '#02a191',
  zdColorSecondaryTeal600: '#028079',
  zdColorSecondaryAzureM400: '#5f8dcf',
  zdColorSecondaryAzureM600: '#3a70b2',
  zdColorSecondaryCrimsonM400: '#cc6c5b',
  zdColorSecondaryCrimsonM600: '#b24a3c',
  zdColorSecondaryFuschiaM400: '#cf62a8',
  zdColorSecondaryFuschiaM600: '#a8458c',
  zdColorSecondaryLemonM400: '#e7a500',
  zdColorSecondaryLemonM600: '#c38f00',
  zdColorSecondaryLimeM400: '#519e2d',
  zdColorSecondaryLimeM600: '#47782c',
  zdColorSecondaryMintM400: '#299c66',
  zdColorSecondaryMintM600: '#2e8057',
  zdColorSecondaryOrangeM400: '#d4772c',
  zdColorSecondaryOrangeM600: '#b35827',
  zdColorSecondaryPinkM400: '#d57287',
  zdColorSecondaryPinkM600: '#b23a5d',
  zdColorSecondaryPurpleM400: '#b072cc',
  zdColorSecondaryPurpleM600: '#9358b0',
  zdColorSecondaryRoyalM400: '#7986d8',
  zdColorSecondaryRoyalM600: '#4b61c3',
  zdColorSecondaryTealM400: '#2d9e8f',
  zdColorSecondaryTealM600: '#3c7873',
  zdColorChatOrange: '#f79a3e',
  zdColorConnectRed: '#eb6651',
  zdColorExploreBlue: '#30aabc',
  zdColorGatherPink: '#e7afa2',
  zdColorGuidePink: '#eb4962',
  zdColorMessageGreen: '#37b8af',
  zdColorSellGold: '#d4ae5e',
  zdColorSupportGreen: '#78a300',
  zdColorTalkYellow: '#efc93d',
  zdFontFamilyMonospace: 'SFMono-Regular,Consolas,"Liberation Mono",Menlo,Courier,monospace',
  zdFontFamilySystem: 'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",Arial,sans-serif',
  zdFontSizeXs: '10px',
  zdFontSizeSm: '12px',
  zdFontSizeMd: '14px',
  zdFontSizeLg: '18px',
  zdFontSizeXl: '22px',
  zdFontSizeXxl: '26px',
  zdFontSizeXxxl: '36px',
  zdFontSizeSmMonospace: '11px',
  zdFontSizeMdMonospace: '13px',
  zdFontSizeLgMonospace: '17px',
  zdFontWeightThin: '100',
  zdFontWeightExtralight: '200',
  zdFontWeightLight: '300',
  zdFontWeightRegular: '400',
  zdFontWeightMedium: '500',
  zdFontWeightSemibold: '600',
  zdFontWeightBold: '700',
  zdFontWeightExtrabold: '800',
  zdFontWeightBlack: '900',
  zdFontWeightUltralight: '200',
  zdFontWeightUltrabold: '800',
  zdFontWeightHeavy: '900',
  zdLineHeightSm: '16px',
  zdLineHeightMd: '20px',
  zdLineHeightLg: '24px',
  zdLineHeightXl: '28px',
  zdLineHeightXxl: '32px',
  zdLineHeightXxxl: '44px',
  zdSpacingXxs: '4px',
  zdSpacingXs: '8px',
  zdSpacingSm: '12px',
  zdSpacing: '20px',
  zdSpacingLg: '32px',
  zdSpacingXl: '40px',
  zdSpacingXxl: '48px'
};
